export class TenderlySimulation {
  public id: string;
  public status: boolean;
  public errorMessage: string | undefined;
  public blockNumber: number;
  public gas: number;
  public gasUsed: number;
  public url: string;

  public isTradeFailed(): boolean {
    return !this.status && this.errorMessage === 'execution reverted';
  }

  public getStatusColor(): string {
    return this.status ? 'green' : 'red';
  }

  public getPublicUrl(): string {
    return `https://dashboard.tenderly.co/shared/simulation/${this.id}`;
  }
}
